export default function addToCartAjax(){

    $('.single_add_to_cart_button').click(function(e){
        e.preventDefault();

        let thisbutton = $(this),
            form = $(thisbutton).closest('form.cart'),
            id = $(thisbutton).val(),
            product_qty = $(form).find('input[name=quantity]').val() || 1,
            product_id = $(form).find('input[name=product_id]').val() || id,
            variation_id = $(form).find('input[name=variation_id]:checked').val() || 0;

        let data = {
            action: 'woocommerce_ajax_add_to_cart',
            product_id: product_id,
            product_sku: '',
            quantity: product_qty,
            variation_id: variation_id,
        };

        $(document.body).trigger('adding_to_cart', [thisbutton, data]);


        $.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: data,
            beforeSend: function (response) {
                $(thisbutton).removeClass('added').addClass('loading');
            },
            complete: function (response) {
                $(thisbutton).addClass('added').removeClass('loading');
            },
            success: function (response) {

                if (response.error ) {
                    toastr["error"]("Error");
                    //window.location = response.product_url;return;
                } else {
                    $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, thisbutton]);
                    toastr["success"]("Added to Cart: <a class='' href='/cart/'><u> View Cart</u></a>");
                }
            },
            error: function (response) {
                toastr["error"]("Error");
            }
        });

    });

}